import React, { createContext, useContext, useState } from "react";
interface BatchDetailsData {
  [key: string]: any;
}

interface MyBatchContextType {
  batchDetailsData: BatchDetailsData | null;
  setbatchDetailsData: any;
  loading: boolean;
  myBatchFilter: any;
  setMyBatchFilter: any;
}

const MyBatchContext = createContext<MyBatchContextType | null>(null);

export const MyBatchContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [batchDetailsData, setbatchDetailsData] =
    useState<BatchDetailsData | null>(null);
  const [myBatchFilter, setMyBatchFilter] = useState<any>(null);
  const values: any = {
    batchDetailsData,
    setbatchDetailsData,
    myBatchFilter,
    setMyBatchFilter,
  };

  return (
    <MyBatchContext.Provider value={values}>{children}</MyBatchContext.Provider>
  );
};

export const useMyBatchContext = (): MyBatchContextType => {
  const context = useContext(MyBatchContext);
  if (!context)
    throw new Error(
      "useMyBatchContext must be used within MyBatchContextProvider"
    );
  return context;
};
